const UpIcon = ({
	className,
	onClick
}: {
	className?: string
	onClick?: () => void
}) => (
	<svg
		class={className}
		fill='currentColor'
		height='12'
		onClick={onClick}
		viewBox='0 0 12 12'
		width='12'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M6 0L0 6L1.0625 7.0625L5.25 2.875V12H6.75V2.875L10.9375 7.0625L12 6L6 0Z'
			fill='currentColor'
		/>
	</svg>
)

export { UpIcon }
